/**
 * AudioView view component.
 * @module components/theme/View/AudioView
 */
 import React from 'react';
 import { defineMessages, useIntl } from 'react-intl';
 import { PageHeader, PageMetadata } from 'iovisit-theme/components/Views';

 /**
  * AudioView view component class.
  * @function AudioView
  * @params {object} content object.
  * @returns {string} Markup of the view.
  */

  const messages = defineMessages({
   copy_text: {
     id: 'copy_text',
     defaultMessage: 'Copia il codice',
   },
   copy_text_label: {
     id: 'copy_text_label',
     defaultMessage: 'Codice di incorporamento audio',
   },
   copy_text_notify: {
     id: 'copy_text_notify',
     defaultMessage: 'Codice audio copiato.',
   },
   transcript_label: {
     id: 'transcript_label',
     defaultMessage: 'Trascrizione',
   },
 });

 const AudioView = ({ content }) => {
   const intl = useIntl();

   const applyText = (file, type) => {
     return '<audio controls><source src="' + file + '" type="' + type + '" /></audio>';
   }

   const copyText = (text) => {
     navigator.clipboard.writeText(text);
     notify(intl.formatMessage(messages.copy_text_notify), {
       state: 'success',
       fix: 'bottom',
     });
   };

   return (
     <>
     <div id="page-audio" className="ui container">
       {/* Testata */}
       <PageHeader content={{ ...content, show_share_links: false }} />

       {/* Embedd audio */}
       {content?.audio_file?.download ? (
         <audio
           controls
           src={content.audio_file.download}
         ></audio>
       ) : (
         <></>
       )}

       {/* Transcript */}
       {(content?.transcript?.data && content?.transcript?.data !== '<p><br></p>') && (
         <div className="transcript-wrapper">
           <p>
             <strong>{intl.formatMessage(messages.transcript_label)}</strong>
           </p>
           <span
             dangerouslySetInnerHTML={{ __html: content.transcript.data }}
           ></span>
         </div>
       )}

        <PageMetadata content={content} />
       </div>
     </>
   );
 };

 export default AudioView;
